import React from 'react';
import axios from 'axios';
import { resolveBackendBaseUrl } from '../../../utils/runtimeConfig';
import { VARIABLE_SAMPLE_VALUES } from './builderModel.js';

const bindingOptions = Object.keys(VARIABLE_SAMPLE_VALUES);

export default function BlockPropertiesForm({
  block,
  onChange,
  onDelete,
  onDuplicate,
  onBringForward,
  onSendBackward,
}) {
  const [uploading, setUploading] = React.useState(false);
  const [uploadError, setUploadError] = React.useState('');
  const isImageBlock = ['logo', 'image'].includes(String(block?.type || '').toLowerCase());

  const updateStyle = (patch) => onChange({ style: { ...block.style, ...patch } });

  const handleUploadLogo = async (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;
    setUploadError('');
    setUploading(true);
    try {
      const token = localStorage.getItem('ktc_token') || localStorage.getItem('access_token') || '';
      if (!token) throw new Error('Sesi login tidak ditemukan. Silakan login ulang.');
      const formData = new FormData();
      formData.append('file', file);
      const base = resolveBackendBaseUrl();
      const res = await axios.post(`${base}/api/upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      const url = String(res.data?.url || '').trim();
      if (!url) throw new Error('URL upload tidak valid');
      onChange({ src: url });
    } catch (err) {
      const message = err?.response?.data?.detail || err?.message || 'Upload logo gagal';
      setUploadError(String(message));
    } finally {
      setUploading(false);
      event.target.value = '';
    }
  };

  return (
    <div className="min-h-0 flex-1 space-y-2 overflow-y-auto pr-1">
      <label className="block text-slate-300">
        Type
        <input value={block.type} disabled className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
      </label>

      <div className="grid grid-cols-2 gap-2">
        <label className="text-slate-300">X
          <input type="number" value={block.x} onChange={(e) => onChange({ x: Number(e.target.value || 0) })} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
        </label>
        <label className="text-slate-300">Y
          <input type="number" value={block.y} onChange={(e) => onChange({ y: Number(e.target.value || 0) })} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
        </label>
        <label className="text-slate-300">W
          <input type="number" value={block.width} onChange={(e) => onChange({ width: Number(e.target.value || 0) })} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
        </label>
        <label className="text-slate-300">H
          <input type="number" value={block.height} onChange={(e) => onChange({ height: Number(e.target.value || 0) })} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
        </label>
      </div>

      <label className="block text-slate-300">
        Binding
        <select
          value={block.binding || ''}
          onChange={(e) => onChange({ binding: e.target.value })}
          className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100"
        >
          <option value="">-</option>
          {bindingOptions.map((b) => <option key={b} value={b}>{b}</option>)}
        </select>
      </label>

      <label className="block text-slate-300">
        Visible When
        <select
          value={block.visible_when || ''}
          onChange={(e) => onChange({ visible_when: e.target.value })}
          className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100"
        >
          <option value="">Always</option>
          <option value="is_same_credential">is_same_credential</option>
          <option value="!is_same_credential">!is_same_credential</option>
          <option value="show_single_code">show_single_code</option>
          <option value="!show_single_code">!show_single_code</option>
        </select>
      </label>

      <label className="block text-slate-300">
        Text
        <textarea value={block.text || ''} onChange={(e) => onChange({ text: e.target.value })} rows={3} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
      </label>

      {isImageBlock ? (
        <div className="space-y-2 rounded border border-cyan-300/20 bg-[#081427]/60 p-2">
          <label className="block text-slate-300">
            Image URL
            <input
              value={block.src || ''}
              onChange={(e) => onChange({ src: e.target.value })}
              placeholder="https://..."
              className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100"
            />
          </label>
          <label className="inline-flex cursor-pointer items-center rounded border border-cyan-300/30 bg-cyan-500/10 px-2 py-1 text-cyan-200">
            {uploading ? 'Uploading...' : 'Upload Logo'}
            <input
              type="file"
              accept="image/png,image/jpeg,image/webp,image/gif"
              className="hidden"
              onChange={handleUploadLogo}
              disabled={uploading}
            />
          </label>
          {uploadError ? (
            <p className="text-xs text-rose-300">{uploadError}</p>
          ) : null}
        </div>
      ) : null}

      <label className="block text-slate-300">
        Triangle Direction
        <select
          value={block.direction || 'right'}
          onChange={(e) => onChange({ direction: e.target.value })}
          className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100"
        >
          <option value="left">left</option>
          <option value="right">right</option>
          <option value="up">up</option>
          <option value="down">down</option>
        </select>
      </label>

      <div className="grid grid-cols-2 gap-2">
        <label className="text-slate-300">Font Size
          <input type="number" value={block.style?.fontSize || 14} onChange={(e) => updateStyle({ fontSize: Number(e.target.value || 14) })} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
        </label>
        <label className="text-slate-300">Weight
          <input type="number" value={block.style?.fontWeight || 500} onChange={(e) => updateStyle({ fontWeight: Number(e.target.value || 500) })} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
        </label>
        <label className="text-slate-300">Text Color
          <input type="color" value={block.style?.color || '#111827'} onChange={(e) => updateStyle({ color: e.target.value })} className="mt-1 h-8 w-full rounded border border-cyan-300/25 bg-[#081427] px-1 py-1" />
        </label>
        <label className="text-slate-300">Fill Color
          <input type="color" value={block.style?.fillColor && block.style?.fillColor !== 'transparent' ? block.style.fillColor : '#0ea5e9'} onChange={(e) => updateStyle({ fillColor: e.target.value, backgroundColor: e.target.value })} className="mt-1 h-8 w-full rounded border border-cyan-300/25 bg-[#081427] px-1 py-1" />
        </label>
        <label className="text-slate-300">BG Color
          <input type="color" value={block.style?.backgroundColor && block.style?.backgroundColor !== 'transparent' ? block.style.backgroundColor : '#ffffff'} onChange={(e) => updateStyle({ backgroundColor: e.target.value })} className="mt-1 h-8 w-full rounded border border-cyan-300/25 bg-[#081427] px-1 py-1" />
        </label>
        <label className="text-slate-300">Border Color
          <input type="color" value={block.style?.borderColor && block.style?.borderColor !== 'transparent' ? block.style.borderColor : '#cbd5e1'} onChange={(e) => updateStyle({ borderColor: e.target.value })} className="mt-1 h-8 w-full rounded border border-cyan-300/25 bg-[#081427] px-1 py-1" />
        </label>
        <label className="text-slate-300">Border Width
          <input type="number" value={block.style?.borderWidth ?? 1} onChange={(e) => updateStyle({ borderWidth: Number(e.target.value || 0) })} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
        </label>
        <label className="text-slate-300">Radius
          <input type="number" value={block.style?.borderRadius || 0} onChange={(e) => updateStyle({ borderRadius: Number(e.target.value || 0) })} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
        </label>
        <label className="text-slate-300">Opacity
          <input type="number" min="0" max="1" step="0.05" value={block.style?.opacity ?? 1} onChange={(e) => updateStyle({ opacity: Number(e.target.value || 1) })} className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100" />
        </label>
      </div>

      <label className="block text-slate-300">
        Text Align
        <select
          value={block.style?.textAlign || 'left'}
          onChange={(e) => updateStyle({ textAlign: e.target.value })}
          className="mt-1 w-full rounded border border-cyan-300/25 bg-[#081427] px-2 py-1 text-slate-100"
        >
          <option value="left">left</option>
          <option value="center">center</option>
          <option value="right">right</option>
        </select>
      </label>

      <div className="grid grid-cols-2 gap-2 text-slate-300">
        <label className="inline-flex items-center gap-1">
          <input type="checkbox" checked={Boolean(block.visible)} onChange={(e) => onChange({ visible: e.target.checked })} />
          Visible
        </label>
        <label className="inline-flex items-center gap-1">
          <input type="checkbox" checked={Boolean(block.locked)} onChange={(e) => onChange({ locked: e.target.checked })} />
          Locked
        </label>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button type="button" onClick={onSendBackward} className="rounded border border-cyan-300/30 bg-cyan-500/10 px-2 py-1 text-cyan-200">
          Send Back
        </button>
        <button type="button" onClick={onBringForward} className="rounded border border-cyan-300/30 bg-cyan-500/10 px-2 py-1 text-cyan-200">
          Bring Front
        </button>
        <button type="button" onClick={onDuplicate} className="rounded border border-cyan-300/30 bg-cyan-500/10 px-2 py-1 text-cyan-200">
          Duplicate
        </button>
        <button type="button" onClick={onDelete} className="rounded border border-rose-300/30 bg-rose-500/10 px-2 py-1 text-rose-200">
          Delete
        </button>
      </div>
    </div>
  );
}
